
export default {
  props: {
    phone: {
      type: String,
      default: '908502251010',
    },
  },
  methods: {
    trackWhatsappClick() {
      if (this.$gtm && this.$gtm.sendLeadRedirectEvent) {
        this.$gtm.sendLeadRedirectEvent('Whatsapp Lead')
      }
    },
  },
}
